
<template>
    <div class="DataUpdate">
      <div class="titlePage">Reprocesar Creditos Financiados</div>
      <ValidationObserver ref="obsFieldsSearch">
        <FormSearchCredit
          :FieldsForm="formSearch"
          :ModelForm="formSchModel"
          :method="executeProcess"
        />
      </ValidationObserver>
      <va-notification
        color="danger"
        id="refNoData"
        class="refNoData noShow"
      >{{this.message}}</va-notification>
      <va-notification
        color="warning"
        id="refDataW"
        class="refDataW noShow"
      >{{this.message}}</va-notification>
      <va-notification
        color="info"
        id="refData"
        class="refData noShow"
      >{{this.message}}</va-notification>
    </div>
  </template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchCredit from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdateGrades from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import XLSX from 'xlsx'

export default {
  name: 'DataUpdate',
  components: {
    FormSearchCredit,
  },
  data () {
    return {
      AlertValidator: '',
      message: '',
      formSchModel: {
        TypeOrden: '',
        Orden: '',
      },
      formSearch: [
        {
          id: 'TypeOrden',
          model: 'TypeOrden',
          name: 'Tipo Orden',
          type: 'Select',
          placeholder: 'Seleccionar...',
          values: [
            { id: 'OMP', value: 'OMP' },
            { id: 'OMC', value: 'OMC' },
            { id: 'OMO', value: 'OMO' },
          ],
          validate: {
            required: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'Orden',
          model: 'Orden',
          name: 'Orden',
          type: 'input',
          placeholder: 'Numero de Orden',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Procesar',
          class: 'col-md-3',
        },
      ],
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      refValidator: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
      }
      this.$refs.obsFieldsSearch.validate()
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      document.getElementById('refDataW').classList.add('noShow')
      document.getElementById('refData').classList.add('noShow')
      this.isNew = false
      const token = IberoHelpers.getToken(this.$store)
      token.then(tokenData => {
        var ListGrades = IberoHelpers.getCreditFinanciera(this.$store, this.formSchModel.TypeOrden, this.formSchModel.Orden, tokenData)
        this.renderComponent1 = false
        ListGrades.then(Response => {
          debugger
          if ((Response.data === undefined) || (Response.data === '') || (Response.data.status === '400')) {
            this.message = Response.data.title
            document.getElementById('refNoData').classList.remove('noShow')
          } else {
            this.message = Response.data.title
            if (this.message.includes('ADVERTENCIA')) {
              document.getElementById('refDataW').classList.remove('noShow')
            }

            if (this.message.includes('OK')) {
              document.getElementById('refData').classList.remove('noShow')
            }
          }
          loader.hide()
        })
      })
    },
  },
}
</script>